export default __webpack_public_path__ + "static/media/guide.938d39f1.png";